import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const {
    language
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const content = {
    en: {
      title: 'FAQ',
      items: [{
        q: 'Does CV Go App guarantee interviews or a job offer?',
        a: 'No. It improves ATS readability and alignment to the job post to increase your chances.'
      }, {
        q: 'What can I input?',
        a: 'Job post: link/text/PDF. Resume: text/PDF. OCR supported.'
      }, {
        q: 'What do I receive?',
        a: 'A tailored ATS-ready resume (editable text + professional PDF), a formal 1-page cover letter (editable text + PDF), plus an in-app improvement report that includes missing keywords.'
      }, {
        q: 'Do you store my data?',
        a: 'No. Privacy-first. Download your results to keep them.'
      }, {
        q: 'Is it unlimited?',
        a: 'You have 12 months of access. For fair use, generations are limited to 5 per day (each generation includes a Resume + Cover Letter bundle).'
      }]
    },
    es: {
      title: 'Preguntas frecuentes (FAQ)',
      items: [{
        q: '¿CV Go App garantiza entrevistas o trabajo?',
        a: 'No. Mejora la legibilidad para ATS y la alineación con la oferta para aumentar tus posibilidades.'
      }, {
        q: '¿Qué puedo ingresar como input?',
        a: 'Oferta: link/texto/PDF. CV: texto/PDF. Con OCR.'
      }, {
        q: '¿Qué recibo exactamente?',
        a: 'Un CV ATS-ready adaptado (texto editable + PDF profesional), una cover letter formal de 1 página (texto editable + PDF) y un reporte de mejoras en la app que incluye missing keywords.'
      }, {
        q: '¿Guardan mi información?',
        a: 'No. Privacidad primero. Descarga tus resultados para conservarlos.'
      }, {
        q: '¿Es ilimitado?',
        a: 'Tienes 12 meses de acceso. Por uso justo, hay un límite de hasta 5 generaciones por día (cada generación incluye el paquete CV + cover letter).'
      }]
    }
  };
  const t = content[language];
  return <section className="py-20 bg-gray-50" data-id="element-13">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-15">
          {t.title}
        </h2>

        <div className="space-y-4" data-id="element-16">
          {t.items.map((item, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === i} data-id="element-18">
                <span className="font-semibold text-gray-900 pr-8" data-id="element-19">
                  {item.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${openIndex === i ? 'transform rotate-180' : ''}`} data-id="element-20" />
              </button>

              <AnimatePresence data-id="element-21">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-22">
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-23">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}